import React, { useState,useContext } from 'react'
import { Menu, Icon, Spin, Dropdown, Avatar, Divider, Breadcrumb } from 'antd'
import  UserContext  from '../../../modules/User/UserContext'
import { appModule } from 'services/module'

export const GlobalHeader= () =>{

	const {loginOut,user} = useContext(UserContext)

	const menu = (
		<Menu className={'menu'} selectedKeys={[]} onClick={loginOut}>
			<Menu.Item>
				<Icon type="logout" />
				退出登录
			</Menu.Item>
		</Menu>
	)

	return (
		<div className="app-index-content-header">
				<div className="app-index-content-title">
					<GlobalHeaderBreadcrumb/>
				</div>

				<div style={{ position: 'absolute', right: '175px', top: '8px' }}>
					<div>
						{/* <span style={{ cursor: 'pointer' }}>
							<Avatar className={'news-avatar'} src={require('../../../assets/image/铃铛.png')} />
							<span style={{ verticalAlign: 'top', lineHeight: '25px', color: 'rgba(102,102,102,1)' }}>
								13
							</span>
						</span> */}
					</div>
				</div>

				<div style={{ position: 'absolute', right: '36px', top: '8px' }}>
					<Dropdown overlay={menu}>
						<span style={{ cursor: 'pointer' }}>
							<Avatar className={'user-avatar'} src={require('../../../assets/image/用户.png')} />

							<span style={{ color: 'rgba(102,102,102,1)', verticalAlign: 'middle' }}>
								{user.userName}
							</span>
						</span>
					</Dropdown>
				</div>
			</div>
	)
}

const GlobalHeaderBreadcrumb = () =>{
	let mo = appModule.getCurrPathModule();
	return <React.Fragment>{mo.name || '个人中心'}</React.Fragment>
}


// WEBPACK FOOTER //
// ./src/layouts/components/GlobalHeader/index.tsx